import { FC, useMemo } from 'react'
import { FutureLayerType, FutureLayerSlug } from 'components/features/future/types'
import styles from 'components/features/future/FutureAllLayersPane/FutureAllLayersPane.styl'
import { LAYER_METAS } from 'constants/future'
import Button from 'components/features/pfm/Button/Button'
import { useStoreSelector } from 'helpers/reactReduxHelpers'
import { retireLayerSelector } from 'components/features/future/selectors'

type ButtonsGroupProps = {
  type: FutureLayerType
  onClick: (slug: FutureLayerSlug) => void
}
export const ButtonsGroup: FC<ButtonsGroupProps> = (props) => {
  const { type, onClick } = props

  const hasRetireLayer = useStoreSelector((state) => {
    return !!retireLayerSelector(state)
  })

  const children = useMemo(() => {
    return Object.keys(LAYER_METAS).map((slug: FutureLayerSlug) => {
      if (slug === 'retirement' && hasRetireLayer) {
        return null
      }

      const meta = LAYER_METAS[slug]

      return meta && type === meta.type && (
        <li key={ slug } className={ styles.buttonWrapper }>
          <Button
            size='square'
            iconSlug={ meta.icon }
            text={ meta.name }
            theme={ meta.type }
            onClick={ () => onClick(slug) }
            shadow='light'
          />
        </li>
      )
    })
  }, [onClick, type, hasRetireLayer])

  return (
    <ul className={ styles.buttonGroup }>
      { children }
    </ul>
  )
}
